import * as React from "react";
import { css } from "aphrodite";
import { withTranslation, WithTranslation } from "react-i18next";
import { DynamicPackageStepIndicatorStyle } from "./DynamicPackageStepIndicatorStyle";

export interface IProps {
  step: number;
  t?: any;
  styles?: any;
}

const barActiveClassArray: any[] = [
  DynamicPackageStepIndicatorStyle.barActive1,
  DynamicPackageStepIndicatorStyle.barActive2,
  DynamicPackageStepIndicatorStyle.barActive3,
];

const itemNumberActiveClass: any[] = [
  DynamicPackageStepIndicatorStyle.itemNumber,
  DynamicPackageStepIndicatorStyle.itemNumberActive,
];

const itemNumberDoneClass: any[] = [
  DynamicPackageStepIndicatorStyle.itemNumber,
  DynamicPackageStepIndicatorStyle.itemNumberDone,
];

const itemTextActiveClass: any[] = [
  DynamicPackageStepIndicatorStyle.itemText,
  DynamicPackageStepIndicatorStyle.itemTextActive,
];

const itemData: any[] = [
  "dynamicPackage.chooseFlight",
  "dynamicPackage.chooseHotel",
  "dynamicPackage.chooseRoom",
];

const titleData: any[] = [
  "dynamicPackage.indicatorFlight",
  "dynamicPackage.indicatorHotel",
  "dynamicPackage.indicatorRoom",
];

class DynamicPackageStepIndicatorComponent extends React.Component<
  IProps & WithTranslation
> {
  public render(): JSX.Element {
    const { step, styles = {}, t } = this.props;
    const { blockStyle } = styles;
    const barActiveClass: any = [
      DynamicPackageStepIndicatorStyle.barActive,
      barActiveClassArray[step - 1],
    ];
    return (
      <div className={css(DynamicPackageStepIndicatorStyle.block, blockStyle)}>
        <div className={css(DynamicPackageStepIndicatorStyle.progress)}>
          <div className={css(DynamicPackageStepIndicatorStyle.bar)} />
          <div className={css(barActiveClass)} />
          {itemData.map((data: string, index: number) => {
            let itemNumberClass: any =
              DynamicPackageStepIndicatorStyle.itemNumber;
            if (step === index + 1) {
              itemNumberClass = itemNumberActiveClass;
            } else if (step > index + 1) {
              itemNumberClass = itemNumberDoneClass;
            }
            const itemTextClass: any =
              index + 1 === step
                ? itemTextActiveClass
                : DynamicPackageStepIndicatorStyle.itemText;
            return (
              <div
                className={css(DynamicPackageStepIndicatorStyle.item)}
                key={index}
              >
                <span className={css(itemNumberClass)}>{index + 1}</span>
                <span className={css(itemTextClass)}>{t(data)}</span>
              </div>
            );
          })}
        </div>
        <div className={css(DynamicPackageStepIndicatorStyle.title)}>
          {t(titleData[step - 1])}
        </div>
      </div>
    );
  }
}

export const DynamicPackageStepIndicator: any = withTranslation([
  "component",
  "label",
])(DynamicPackageStepIndicatorComponent);
